// interface TechResponse {
// 	tech_report: {
// 		Total_score: string;
// 	};
// 	questions: {
// 		question: string;
// 		correct_answer: string;
// 		user_answer: string;
// 		Selected_choice: string;
// 	}[];
// }

const CandidateTechnicalScore = ({ techResponses }: any) => {
	if (!techResponses) {
		return <div>No technical responses available</div>;
	}
	try {
		techResponses =
			typeof techResponses == "string"
				? JSON.parse(techResponses)
				: techResponses;
	} catch (error) {
		return <div>Error parsing technical responses</div>;
	}
	return (
		<div className="mb-6 font-subheading">
			<h2 className="text-xl  text-gray-800 dark:text-white ">
				Technical Response
			</h2>
			<h3 className="text-gray-700 mt-2 mb-4 ml-2 ">
				Correctly Answered Question : {techResponses.tech_report.Total_score}
			</h3>

			<div className="flex justify-center overflow-x-auto shadow-xl rounded-md">
				<table className="w-full border-collapse border  text-sm">
					<thead>
						<tr className="bg-gray-100">
							<th className="p-3 border-r text-left">Question</th>
							<th className="p-1 border-r text-left w-[120px]">
								Correct Answer
							</th>
							<th className="p-1 border-r text-left w-[120px]">User Answer</th>
							<th className="p-1 border-r  text-left w-[120px]">
								Selected Choice
							</th>
						</tr>
					</thead>

					<tbody className="font-body">
						{techResponses.questions.map((question: any, index: number) => (
							<tr key={index}>
								<td className="p-2 border-r ">{question.question}</td>
								<td className="p-2 border-r">
									{"Option " + question.correct_answer}
								</td>
								<td className="p-2 border-r ">
									{"Option " + question.user_answer}
								</td>
								<td
									className={`${
										question.correct_answer === question.user_answer
											? "text-[#009617]"
											: "text-[#F63C3C]"
									} p-2 border-r`}
								>
									{question.Selected_choice === "right"
										? "Correct"
										: "Incorrect"}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};
export default CandidateTechnicalScore;
